import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import { iframeResizer as iframeResizerLib } from 'iframe-resizer';

var IFrameResizer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IFrameResizer, _React$Component);

  function IFrameResizer(_props) {
    var _this;

    _classCallCheck(this, IFrameResizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IFrameResizer).call(this, _props));

    _this.resizeIframe = function (props) {
      if (!_this.frameRef.current) return;

      if (props.iframeResizerEnable) {
        iframeResizerLib(props.iframeResizerOptions, _this.frameRef.current);
      }
    };

    _this.frameRef = React.createRef();
    return _this;
  }

  _createClass(IFrameResizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeIframe(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // React will remove the iframe, however we need to manually
      // call iframe-resizer to stop its listeners
      var iframeResizer = this.frameRef.current.iFrameResizer;
      iframeResizer && iframeResizer.removeListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          id = _this$props.id,
          frameBorder = _this$props.frameBorder,
          className = _this$props.className,
          style = _this$props.style;
      return React.createElement("iframe", {
        ref: this.frameRef,
        src: src,
        id: id,
        frameBorder: frameBorder,
        className: className,
        style: style
      });
    }
  }]);

  return IFrameResizer;
}(React.Component);

IFrameResizer.defaultProps = {
  // resize iframe
  iframeResizerEnable: true,
  iframeResizerOptions: {// log: true,
    // autoResize: true,
    // checkOrigin: false,
    // resizeFrom: 'parent',
    // heightCalculationMethod: 'max',
    // initCallback: () => { console.log('ready!'); },
    // resizedCallback: () => { console.log('resized!'); },
  },
  // misc props to pass through to iframe
  frameBorder: 0,
  style: {
    width: '100%',
    minHeight: 20
  }
};
export default IFrameResizer;